module.exports = __webpack_public_path__ + "img/slide15.0670ea1e.png";